import { CATEGORY_PATHS } from '~/bootcamp/constants/bootcamp.const'
import { LevelKey, LevelActionType, CategoryPathUrls } from '~/bootcamp/types/bootcamp.types'
import { Activity } from '~/types/bootcamp'

export function levelKey(level: string, type: string = LevelActionType.Activity, activityLevel = 1): LevelKey {
  return `${level}-${type}-${activityLevel}`
}

export function getActivityProperty<K extends keyof Activity['difficulties'][number]>(
  activites: Activity[],
  key: K,
  activityType: number,
  difficultyLevel: number,
): Activity['difficulties'][number][K] | undefined {
  const typeObj = activites.find((activity) => activity.type === activityType)
  const level = typeObj?.difficulties.find((elem) => elem.difficultyLevel === difficultyLevel)
  return level?.[key]
}

export function checkIfLevelComplete(completedLeafs: string[] | undefined, level: string): boolean {
  if (completedLeafs && completedLeafs.length > 0) {
    return completedLeafs.includes(level)
  }
  return false
}

export function getActivityDiffLevelsCount(activites: Activity[], activityType: number): number {
  const typeObj = activites.find((activity) => activity.type === activityType)
  const levels = typeObj?.difficulties.map((elem) => elem.difficultyLevel)
  return levels ? levels.length : 0
}

export function getActivityTypesCount(activities: Activity[]): number {
  const types = activities.map((activity) => activity.type)
  return types ? types.length : 0
}
export function isActivityNotFound(activityType: number, activityTypesCount: number): boolean {
  return !activityType || !Number.isInteger(activityType) || activityType < 1 || activityTypesCount < activityType
}
export function isVideoTopicNotFound(subtopic: CategoryPathUrls): boolean {
  return !Object.values(CATEGORY_PATHS).includes(subtopic)
}
